<div class="w-100 d-flex justify-content-center align-items-center flex-shrink-0"
  [ngClass]="{'overlay-fixed' : isFullScreen === 1, 'overlay-absolute': isFullScreen === 2}">
  <img
    [src]="isSmallLoading ? 'assets/samvaad-assets/images/icons/primary-loader.gif' : 'assets/samvaad-assets/images/icons/img-video-loader.gif'"
    alt="" [width]="width" [height]="height">
</div>
